import React, { ReactElement } from 'react';

import {
  ScalingMode,
  StyleObject,
  ViewStylesObject,
} from '@bighealth/types/src/scene-components/client';

import { useTransformStylesToContext } from 'components/ResponsiveLayout';

import { CommonPlayer } from '../Common';
import { ComponentMediaProps } from '../types';

type VideoProps = ComponentMediaProps & {
  style?: ViewStylesObject;
  scaling?: ScalingMode;
};

export const Video = ({
  style,
  scaling,
  ...rest
}: VideoProps): ReactElement => {
  const transformStylesToContext = useTransformStylesToContext();
  const scaledStyles = transformStylesToContext(
    style || ({} as StyleObject),
    scaling
  );
  return <CommonPlayer {...rest} style={scaledStyles} />;
};
